(function () {
  window.abrwl = window.abrwl || {};
  window.abrwl.strings = window.abrwl.strings || {};
  // window.abrwl.apiEndpoint = '/apps/wishlist'
  // window.abrwl.pageHandle = 'wishlist';
  window.abrwl.rootUrl = Theme.routes.root_url;
  Object.assign(window.abrwl.strings, {
    loadMoreButton: Theme.translations.load_more,
    addToWishlist: Theme.translations.wishlist_add,
    removeFromWishlist: Theme.translations.wishlist_remove,
  });
})();
